<template>
	<div class="change_style_ptgame" ref="minHeight">
		<img src="@/static/img/ptgames/banner.webp" alt="banner" class="banner" />
		<div class="top_img_box" :aaa="gameId">
			<a
				v-for="api of $store.state.apiTypeMap[4].api"
				:key="api.img"
				:class="api.game === gameId ? 'active' : 'default'"
				@click="gameId = api.game"
				href="javascript:"
			>
				<div class="img-default tab">
					<p>{{ api.name }}</p>
				</div>
				<div class="img-active tab">
					<img :src="require(`@/static/img/ptgames/${api.img}.webp`)" alt="" />
					<p>{{ api.name }}</p>
				</div>
			</a>
		</div>
		<div class="content">
			<!--艺游操作部分-->
			<div class="pt-black-bg">
				<!--左侧按钮-->
				<div class="box_center ptGames-handel">
					<!--右侧搜索-->
					<div class="search-ptgames-container">
						<input type="text" v-model="name" @keydown.enter="searchGame" placeholder="查询游戏" />
						<span class="search-ptgames-pic" @click="searchGame"></span>
					</div>
				</div>
			</div>
			<!--艺游游戏部分-->
			<div
				class="pt-gray-bg"
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.5)"
			>
				<div class="pt-games-container">
					<div class="pt-games-items-container" v-for="(item, index) in gamesArr" :key="index">
						<div class="pt-games-items">
							<div class="pt-games-item-pic">
								<img :src="url + item.imgurl" />
								<div class="pt-games-item-button">
									<a href="javascript:" class="start-btn" @click="toGame(item)">开始游戏</a>
								</div>
							</div>
							<div class="pt-games-item-title">
								<span class="PGIT-name">{{ item.cn_name }}</span>
							</div>
						</div>
					</div>
					<!--未找到游戏-->
					<div class="pt-games-noFind" v-if="!gamesArr || gamesArr.length === 0">
						<img src="@/static/img/ptgames/nofind.webp" alt="nofind" />
						<span class="pt-games-noFind-text">暂无收录游戏</span>
					</div>
				</div>
				<div class="pt-games-pagination" v-if="gamesArr.length > 0">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						background
						prev-text="上一页"
						next-text="下一页"
						:current-page="PIndex"
						:page-sizes="[15, 30, 50, 100]"
						:page-size="PSize"
						layout="total, prev, pager, next, jumper"
						:total="total"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { postAjax, getAjax } from "../../util/ajax.js";
import { SysKey } from "../../util/sysconfig";
import { game } from "../../mixins/game";

export default {
	mixins: [game],
	data() {
		return {
			loading: false,
			loadGame: false,
			name: "", //游戏名
			PIndex: 1, //页数
			PSize: 15, //每页条数
			gameId: 7, //默认加载的游戏id
			gamesArr: [], //游戏数组
			total: 1, //总页数
			url: SysKey("ImgServerUrl").SysValue,
			userinfo: {}, //用户信息
			errorMassge: "",
			apiList: this.$store.state.apiTypeMap["4"].api, // 电子类下面的所有API
		};
	},
	created() {
		this.gameId = Number(this.$route.query.game) || 7;
	},
	computed: {
		isLogin() {
			return this.$store.state.loginStatus;
		},
	},
	watch: {
		gameId() {
			this.getGamesArr();
		},
		$route() {
			this.gameId = Number(this.$route.query.game) || 7;
		},
	},
	methods: {
		_initOpenLoading(isFlag = true) {
			this.loading = this.$loading({
				lock: true,
				text: `${isFlag ? "投注中" : "加载中"}...`,
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.5)",
			});
		},
		_initCloseLoading() {
			this.loading.close();
			this.loading = false;
		},
		searchGame() {
			this.getGamesArr();
		},
		//得到游戏
		getGamesArr() {
			this.loading = true;
			let that = this;
			let url = `api/ThirdGame/GetGameList?g=${this.gameId}&d=1`;
			let data = {
				name: this.name,
				PIndex: this.PIndex,
				PSize: this.PSize,
				Category: 102,
			};
			postAjax(url, data).then(function (data) {
				if (data.IsSucess) {
					if (data.Data == null) {
						that.gamesArr = [];
						that.total = 0;
						that.loading = false;
					} else {
						that.gamesArr = data.Data.rows;
						that.total = data.Data.total;
						that.loading = false;
					}
				}
			});
		},
		handleSizeChange(e) {
			this.PSize = e;
			this.getGamesArr();
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.PIndex = e;
			this.getGamesArr();
		},
		//按需拉取游戏数据
		getGameList(e) {
			this.name = "";
			this.gameId = e.target ? e.target.dataset.id : e;
			this.PIndex = 1;
		},
	},
	mounted() {
		this.getGamesArr();
	},
};
</script>

<style lang="scss">
.change_style_ptgame {
	width: 100%;
	min-width: 1200px;
	padding-top: 17px;
	padding-bottom: 71px;
	background: #c6cdd9 url("~@/static/img/bg.webp");
	background-repeat: no-repeat;
	position: relative;
	.banner {
		position: absolute;
		top: 50px;
		left: 50%;
		transform: translateX(-47%);
	}

	.pt-games-adPic {
		width: 1200px;
		margin: 0 auto;
		font-size: 0;

		img {
			margin: 0 auto;
		}
	}

	.top_img_box {
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
		margin: 345px auto 0;
		align-items: flex-end;

		a {
			position: relative;
			width: 196px;
			height: 74px;
			margin-right: 10px;

			&.default {
				position: relative;
				background-image: url(~@/static/img/ptgames/ptGame-bg-default.webp);
				background-repeat: no-repeat;
				background-position: 0 100%;
				width: 176px;
				height: 50px;
				.img-default {
					display: block;
					display: flex;
					align-items: center;
					justify-content: center;
					height: 100%;
					p {
						color: #6455fe;
						// font-weight: 600;
						font-weight: 400;
					}
				}

				.img-active {
					display: none;
				}
			}

			&:hover,
			&.active {
				position: relative;
				background-image: url(~@/static/img/ptgames/ptGame-bg-active.webp);
				background-repeat: no-repeat;
				width: 176px;
				height: 90px;
				display: flex;
				align-items: center;
				justify-content: center;
				.img-default {
					display: none;
				}
				.img-active {
					display: block;
				}
			}
			.tab {
				p {
					font-size: 18px;
					color: #fff;
					text-align: center;
					font-weight: 400;
				}
			}
		}
	}

	.content {
		width: 1200px;
		margin: 0px auto;
		border-radius: 10px 10px 10px 10px;
	}

	.pt-black-bg {
		width: 100%;
		height: 50px;
		background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);
		.ptGames-handel {
			width: 100%;
			height: 100%;
			padding: 0 30px 0 20px;
			div {
				float: left;

				.ptGames-button {
					display: inline-block;
					width: 112px;
					height: 40px;
					font-size: 14px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 39px;
					letter-spacing: 0;
					color: #171717;
					text-align: center;
					border-radius: 20px;
					cursor: pointer;

					&:hover {
						color: #ffffff;
						background-color: #d86556;
					}
				}

				.select_ptGames_nav {
					color: #ffffff;
					background-color: #d86556;
				}
			}

			.search-ptgames-container {
				float: right;
				position: relative;
				width: 306px;
				height: 26px;
				margin-top: 7px;

				input {
					width: 100%;
					height: 32px;
					padding: 0 40px 0 15px;
					font-size: 14px;
					box-shadow: inset 5.7px 5.7px 6px 0 rgba(0, 0, 0, 0.03);
					background: #fff;
					border: none;
					color: #a392fe;
					position: relative;

					&:focus {
						outline: none;
					}

					&::placeholder {
						color: #a392fe;
						font-size: 13px;
					}
				}

				.search-ptgames-pic {
					cursor: pointer;
					height: 100%;
					width: 40px;
					height: 32px;
					position: absolute;
					top: 0;
					right: 0;
					background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);

					&::after {
						content: "";
						position: absolute;
						top: 0;
						right: 0;
						background-image: url("~@/static/img/ptgames/ptsearch.webp");
						background-repeat: no-repeat;
						background-position: 50%;
						width: 100%;
						height: 100%;
						border-left: 1px solid #99abb36c;
					}
				}
			}

			&:after {
				content: "";
				clear: both;
			}
		}
	}

	.pt-gray-bg {
		width: 100%;
		padding: 0 0 36px;
		background-color: #e1e6f1;
		border-radius: 0 0 10px 10px;

		.pt-games-container {
			display: flex;
			margin: 0 auto;
			justify-content: flex-start;
			flex-wrap: wrap;
			padding: 0 5px;

			.pt-games-items-container {
				width: 238px;
				height: 200px;
				margin: 10px 0 0;
				padding: 0 5px 0;
				background-color: #e1e6f1;

				.pt-games-items {
					.pt-games-item-title {
						width: 100%;
						height: 36px;
						display: flex;
						justify-content: center;
						align-items: center;
						font-size: 16px;
						font-stretch: normal;
						letter-spacing: 0;
						color: #fff;
						background-image: url(~@/static/img/ptgames/bar.webp);
						background-repeat: no-repeat;
						background-size: cover;
					}

					.pt-games-item-pic {
						position: relative;
						width: 100%;
						height: 150px;
						background-color: #e8eaf7;
						font-size: 0;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.pt-games-item-button {
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						width: 100%;
						display: none;
						background-color: rgba(0, 0, 0, 0.5);
						transition: 0.3s;

						.start-btn {
							display: block;
							width: 90px;
							height: 24px;
							line-height: 24px;
							margin: 10px auto;
							border-radius: 5px;
							background-color: #1e8edd;
							font-size: 12px;
							color: #ffffff;
							text-align: center;
							display: block;
							transition: 0.3s;
							&:hover {
								opacity: 0.8;
							}
						}
					}
				}

				&:hover {
					.pt-games-item-button {
						display: flex;
					}
				}
			}

			//没有游戏的时候显示
			.pt-games-noFind {
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 100px;

				img {
					width: 100px;
				}

				.pt-games-noFind-text {
					font-size: 13px;
					color: rgb(122, 122, 122);
					padding: 20px;
				}
			}
		}

		//页脚分页器
		.pt-games-pagination {
			text-align: center;
			margin-top: 30px;

			.btn-prev,
			.btn-next {
				padding: 0 5px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ptGames/ptGames.vue